<template lang="pug">
.menu-item(:class='{extended}')
  .major(@click='onClickMajor')
    .icon(:class='item.icon')
    .label {{ item.label }}
    .btn(v-if='item.children')
  .minor(v-if='item.children && extended', v-for='c in item.children', @click='onClickMinor(c)')
    .label {{ c.label }}
</template>

<style lang="less">
@import '~@/assets/common.less';
.menu-item:extend(.full-width, .relative) {
  > *:extend(.relative, .full-width) {
    height: 52px;
  }
  .major {
    > *:extend(.absolute) {}
    .icon {
      left: 28px;
      top: 14px;
      width: 24px;
      height: 24px;
      background-size: auto 100% !important;
    }
    .label:extend(.center-mid, .full-height) {
      width: 200px;
      left: 72px;
      font-family: Poppins;
      font-size: 14px;
      font-weight: 500;
      font-stretch: normal;
      font-style: normal;
      text-align: left;
      color: #ffffff;
      -webkit-box-pack: initial;
    }
    .icon.bar { background: url(~@/assets/imgs/icon_menu_bar_n.png) no-repeat center; }
    .icon.cal { background: url(~@/assets/imgs/icon_menu_cal_n.png) no-repeat center; }
    .icon.chat { background: url(~@/assets/imgs/icon_menu_chat_n.png) no-repeat center; }
    .icon.doc { background: url(~@/assets/imgs/icon_menu_doc_n.png) no-repeat center; }
    .icon.help { background: url(~@/assets/imgs/icon_menu_help_n.png) no-repeat center; }
    .icon.home { background: url(~@/assets/imgs/icon_menu_home_n.png) no-repeat center; }
    .btn {
      background: url(~@/assets/imgs/btn_dropdown.svg) no-repeat center;
      right: 30px;
      top: 26px;
      width: 10px;
      height: 6px;
    }
  }
}
.menu-item.extended {
  background-color: white;
  .major {
    .label {
      color: #179bb5;
    }
    .btn {
      background: url(~@/assets/imgs/btn_shotup.svg) no-repeat center;
    }
  }
  .minor {
    .label:extend(.absolute, .center-mid, .full-height) {
      width: 200px;
      left: 83px;
      font-family: Poppins;
      font-size: 14px;
      font-weight: 500;
      font-stretch: normal;
      font-style: normal;
      text-align: left;
      color: #179bb5;
      -webkit-box-pack: initial;
    }
  }
}
</style>

<script>
export default {
  props: {
    item: {
      type: Object,
      default: () => ({label: ''})
    },
    extended: {
      type: Boolean,
      default: false
    }
  },
  methods: {
    onClickMajor () {
      if (this.item.href) {
        return this.$emit('selected', this.item)
      }
      if (this.item.children) {
        this.$emit('update:extended', !this.extended)
      }
    },
    onClickMinor (c) {
      if (c.href) {
        return this.$emit('selected', c, this.item)
      }
    }
  }
}
</script>



// WEBPACK FOOTER //
// src/components/menu/menuItem.vue